var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.16,
    y: 18.57,
    width: 12.84,
    height: 8.41,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 18.57,
    width: 12.84,
    height: 8.41,
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.16,
    y: 8.75,
    width: 29.68,
    height: 5.82,
    fill: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.16,
    y: 30.98,
    width: 12.84,
    height: 8.27,
    fill: "none"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 30.98,
    width: 12.84,
    height: 8.27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.84,4.75H7.16c-1.11,0-2,.89-2,2V41.25c0,1.11,.89,2,2,2H40.84c1.11,0,2-.89,2-2V6.75c0-1.11-.89-2-2-2Zm-2,4v5.82H9.16v-5.82h29.68Zm-12.84,9.82h12.84v8.41h-12.84v-8.41Zm-4,8.41H9.16v-8.41h12.84v8.41Zm-12.84,4h12.84v8.27H9.16v-8.27Zm16.84,8.27v-8.27h12.84v8.27h-12.84Z",
    fill: outlineColor
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTable);
export default __webpack_public_path__ + "static/media/ico-table.56645f1109a25d6393e9fee1d902321a.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;